import type { FC, ReactNode } from 'react';

import type { IconName } from '@zen/Styleguide';

import { IconButton } from '../../../Button';

interface Props {
  groupKey: string;
  isCollapsed: boolean;
  isCollapsible: boolean;
  label: ReactNode;
  onToggleCollapse: () => void;
}

const TableGroupHeader: FC<Props> = (props) => {
  const { groupKey, isCollapsed, isCollapsible, label, onToggleCollapse } = props;

  const collapseIcon: IconName = isCollapsed ? 'zicon-chevron-right' : 'zicon-chevron-down';
  const collapseLabel: string = isCollapsed ? `Expand group ${groupKey}` : `Collapse group ${groupKey}`;

  return (
    <div className="flex items-center gap-2" data-component="table-group-header">
      {isCollapsible && (
        <IconButton
          aria-expanded={!isCollapsed}
          icon={collapseIcon}
          onClick={onToggleCollapse}
          showTooltip={false}
          size="medium"
          title={collapseLabel}
          variant="ghost"
        />
      )}
      <span className="text-xs leading-4">{label}</span>
    </div>
  );
};

export type { Props as TableGroupHeaderProps };
export default TableGroupHeader;
